<h2 mat-dialog-title class="fs-5 fw-semibold mb-2">Add Permission</h2>

<mat-dialog-content>
  <form [formGroup]="capabilityForm" (ngSubmit)="saveCapability()" class="w-100">

    <!-- Select Type -->
    <div class="mb-2">
      <label class="form-label small mb-1 d-block">Select Type</label>
      <mat-radio-group 
        formControlName="capabilityType" 
        (change)="selecteType($event.value)"
        class="d-flex gap-3"
      >
        <mat-radio-button 
          *ngFor="let type of capabilityTypes" 
          [value]="type" 
          class="me-3"
        >
          {{ type | titlecase }}
        </mat-radio-button>
      </mat-radio-group>
    </div>

    <!-- CRUD Options -->
    <div *ngIf="capabilityType === 'crud'" class="mb-2">
      <label class="form-label small mb-1 d-block">Permissions</label>
      <div class="d-flex gap-3 flex-wrap">
        <mat-checkbox
          *ngFor="let option of crudOption"
          [checked]="types[option]"
          (change)="checkboxChange(option, $event)"
        >
          {{ option | titlecase }}
        </mat-checkbox>
      </div>
    </div>

    <!-- Name Field -->
    <mat-form-field appearance="fill" class="w-100 mb-2">
      <mat-label>Name</mat-label>
      <input matInput formControlName="name" [maxlength]="50" />
      <mat-error *ngIf="submitted && capabilityForm.get('name')?.hasError('required')">
        Name is required
      </mat-error>
    </mat-form-field>

    <!-- Module Select -->
    <mat-form-field appearance="fill" class="w-100 mb-0">
      <mat-label>Module Name</mat-label>
      <mat-select formControlName="selectedModule">
        <mat-option *ngFor="let module of modules" [value]="module.name">
          {{ module.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <!-- Dialog Buttons -->
    <mat-dialog-actions class="d-flex justify-content-end gap-2 mt-2">
      <button mat-raised-button type="submit" color="primary">Save</button>
      <button mat-stroked-button type="button" color="warn" (click)="close()">Cancel</button>
    </mat-dialog-actions>

  </form>
</mat-dialog-content>


